module.exports = __webpack_public_path__ + "img/Pattern2.02a3a655.svg";